<div class="btn-toolbar">
    <div class="btn-group" [sq-action-buttons]="{items: [action]}"></div>
</div>